import { render, staticRenderFns } from "./SoftwareStatus.vue?vue&type=template&id=b7d3bbc8&scoped=true&"
import script from "./SoftwareStatus.vue?vue&type=script&lang=js&"
export * from "./SoftwareStatus.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareStatus.vue?vue&type=style&index=0&id=b7d3bbc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d3bbc8",
  null
  
)

export default component.exports